const ACTIVE_SIDEBAR_ITEM: string = 'ACTIVE_SIDEBAR_ITEM';
const USER_DATA: string = 'USER_DATA';
const MODELS_DATA: string = 'MODELS_DATA';
const SUPPLIERS_DATA: string = 'SUPPLIERS_DATA';
const PHONES_DATA: string = 'PHONES_DATA';
const ALL_PHONES_DATA: string = 'ALL_PHONES_DATA';
const UPDATE_PHONE: string = 'UPDATE_PHONE';
const ALL_CLIENTS_DATA: string = 'ALL_CLIENTS_DATA';
const ALL_EXPENSES_DATA: string = 'ALL_EXPENSES_DATA';
const REPORTS_DATA: string = 'REPORTS_DATA';
const STAFF_USERS_DATA: string = 'STAFF_USERS_DATA';
const ALL_STORES_DATA: string = 'ALL_STORES_DATA';
const ALL_STORES_LOADING: string = 'ALL_STORES_LOADING';
const ALL_STORES_ERROR: string = 'ALL_STORES_ERROR';
const LOGS_ACTIVITIES_DATA: string = 'LOGS_ACTIVITIES_DATA';
const DASHBOARD_STAT_DATA: string = 'DASHBOARD_STAT_DATA';
const STOCK_SUMMARY_DATA: string = 'STOCK_SUMMARY_DATA';
const GENERAL_DASHBOARD_STAT_DATA: string = 'GENERAL_DASHBOARD_STAT_DATA';
const ALL_GENERAL_SALES_DATA: string = 'ALL_GENERAL_SALES_DATA';
const ALL_GENERAL_CLIENTS_DATA: string = 'ALL_GENERAL_CLIENTS_DATA';
const GENERAL_REPORTS_DATA: string = 'GENERAL_REPORTS_DATA';

const TYPES: any= {
    ACTIVE_SIDEBAR_ITEM,
    USER_DATA,
    MODELS_DATA,
    SUPPLIERS_DATA,
    PHONES_DATA,
    ALL_PHONES_DATA,
    UPDATE_PHONE,
    ALL_CLIENTS_DATA,
    ALL_EXPENSES_DATA,
    REPORTS_DATA,
    STAFF_USERS_DATA,
    ALL_STORES_DATA,
    ALL_STORES_LOADING,
    ALL_STORES_ERROR,
    LOGS_ACTIVITIES_DATA,
    DASHBOARD_STAT_DATA,
    STOCK_SUMMARY_DATA,
    GENERAL_DASHBOARD_STAT_DATA,
    ALL_GENERAL_SALES_DATA,
    ALL_GENERAL_CLIENTS_DATA,
    GENERAL_REPORTS_DATA
};

export default TYPES;
